import { Injectable } from '@angular/core';
import { Benutzer } from '@karl/entities';
import { map, Observable, tap } from 'rxjs';
import { RestUserService } from '../../../rest/user.service';
import { RouterService } from '../../services/router.service';
import { PayloadUtil } from '../../util/payload.util';
import { fromLocalStorage, fromSessionStorage } from '../store.service';

export interface CookieConsentData {
  functional?: boolean;
  cookieDialogShown: boolean;
}

@Injectable({providedIn: 'root'})
export class CookieConsentStore {

  readonly settingKey = 'cookieconsent';
  readonly currentSettings = fromLocalStorage<CookieConsentData>(this.settingKey);

  updateFunctionalCookieSetting(functional: boolean): void {
    this.currentSettings.set({
      functional:        functional,
      cookieDialogShown: true
    });
  }

  setCookieDialogShown(): void {
    this.currentSettings.set({
      cookieDialogShown: true
    });
  }

  public clearSettings(): void {
    this.currentSettings.set(null);
  }

}
